/* eslint-disable no-mixed-spaces-and-tabs */
import axiosInstance from '../Lib/axios';
import {
  LINK_PAYMENT_SUCCESSFULLY,
  LINK_PAYMENT_FAILED,
} from './types';

// Send stax info to BE
export const linkPayment = (params) => {
  return (dispatch) => {
	  return axiosInstance
      .post(`/crm/payment/link-payment/`, params)
      .then((response) => {
		  dispatch({
          type: LINK_PAYMENT_SUCCESSFULLY,
          payload: response?.data,
		  });
      })
      .catch((error) => {
		  if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
		  }
		  if (error?.response) {
          dispatch({
			  type: LINK_PAYMENT_FAILED,
			  data: error?.response?.data,
          });
		  }
      });
  };
};